// Upgrade moments. A locked control or a reached cap opens the upgrade dialog through `showUpgrade` (UpgradeHost in
// App.vue shows it); a 402 from the API opens a view's own dialog with the API's sentence. Which plan, its name and
// what it adds come from the workspace's plan matrix (lib/plans.js), never from text written here.
import Vue from 'vue';

export const upgradeState = Vue.observable({ open: false, detail: null });

// `detail`: {feature} for a locked control, {feature, used} for a reached cap, or a 402's plan_limit detail.
export function showUpgrade(detail) {
  upgradeState.detail = detail;
  upgradeState.open = true;
}

// {feature, used} when `current` already uses everything the plan allows for `key` and a higher plan allows more
// (`target`, the store's availableOn), else null: at the top plan's limits the API's own message applies instead.
export function limitReached(key, limits, current, target) {
  const allowed = limits ? limits[key] : null;
  if (!target || typeof allowed !== 'number' || (current || 0) < allowed) return null;
  return { feature: key, used: current || 0 };
}
